import React from "react";
import ConsultaMultas from "./ConsultaMultas";

const App = () => {
  return <ConsultaMultas />;
};

export default App;
